import styled from "styled-components";
import { useState } from "react";

import Overlay from "../Overlay";
import Modal from "../Utils/Modal";
import Formulario from "../Utils/Formulario";
import FormComp from "../FormComp";

import useApi from "../../hooks/useApi";
import { useModal } from "../../contexts/ModalContext";

const WrapperBotoes = styled.div`
    margin-top: 15px;
    display: flex;
    justify-content: flex-end;
`;
const BotaoSalvar = styled.button`
    background-color: #2563eb;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    padding: 10px 12px;
    transition: 0.2s all ease;
    margin: 15px 0 0 0;
    &:hover { background-color: #1e40af; }
    &:disabled { background-color: #93c5fd; cursor: auto; }
`;
const BotaoCancelar = styled.button`
    background-color: #e5e7eb;
    color: #333;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    padding: 10px 12px;
    margin: 15px 10px 0 0;
    transition: 0.2s all ease;
    &:hover { background-color: #d1d5db; }
`;

const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const ModalNovoEmailTransferencia = ({ obras, fetchData }) => {

    const api = useApi();
    const { closeModal } = useModal();

    const [cc, setCc] = useState("");
    const [nome, setNome] = useState("");
    const [email, setEmail] = useState("");
    const [emailValido, setEmailValido] = useState(true);
    const [saving, setSaving] = useState(false);

    const verifyEmail = (value) => {
        setEmailValido(EMAIL_REGEX.test(value));
    };

    const camposOk = cc.trim() !== "" && nome.trim() !== "" && email.trim() !== "" && emailValido;

    const handleSubmit = async (e) => {

        e.preventDefault();

        if (!camposOk) {
            alert("Preencha o CC, nome e um e-mail válido.");
            return;
        }

        setSaving(true);

        try {

            const formData = new FormData();
            formData.append("cc", cc);
            formData.append("nome", nome);
            formData.append("email", email);

            await api.post('/Painel/API/Transferencia/AddEmail/', formData);

            await fetchData();
            closeModal();

        } catch (err) {

            const message = err?.response?.data?.message || 'Erro ao salvar e-mail.';
            alert(message);
            console.log(err);

        } finally {

            setSaving(false);

        }

    };

    return (
        <Overlay state={true}>
            <Modal size="sm">
                <Formulario onSubmit={handleSubmit}>
                    <FormComp
                        title="CENTRO DE CUSTO"
                        valor={cc}
                        type="select"
                        options={obras ?? []}
                        changeFunc={(e) => setCc(e.target.value)}
                    />
                    <FormComp
                        title="NOME"
                        valor={nome}
                        type="text"
                        changeFunc={(e) => setNome(e.target.value.toUpperCase())}
                    />
                    <FormComp
                        title="E-MAIL"
                        valor={email}
                        type="text"
                        changeFunc={(e) => setEmail(e.target.value.toLowerCase())}
                        onBlur={() => verifyEmail(email)}
                        invalid={!emailValido}
                    />
                    <WrapperBotoes>
                        <BotaoCancelar
                            type="button"
                            onClick={() => closeModal()}
                        >
                            CANCELAR
                        </BotaoCancelar>
                        <BotaoSalvar
                            type="submit"
                            disabled={!camposOk || saving}
                        >
                            SALVAR
                        </BotaoSalvar>
                    </WrapperBotoes>
                </Formulario>
            </Modal>
        </Overlay>
    );

};

export default ModalNovoEmailTransferencia;
